export enum ComboStatus {
	ALL = "all",
	GOING_ON = "going_on",
	COMING = "coming",
	EXPIRED = "expired",
}
